import { useState } from 'react';
import useDishStore from '../store/dishStore';

/**
 * Custom hook for managing dish dialog state and operations
 * @returns {Object} - Dish dialog state and handlers
 */
const useDishDialog = () => {
  const { updateDish, addDish } = useDishStore();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedDish, setSelectedDish] = useState(null);

  const handleDishClick = (dish) => {
    setSelectedDish(dish);
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setSelectedDish(null);
    setDialogOpen(false);
  };

  const handleAddNewDish = () => {
    setSelectedDish(null); // No dish = create mode
    setDialogOpen(true);
  };

  const handleDishSave = async (dishPayloads) => {
    try {
      if (selectedDish) {
        await updateDish(selectedDish.id, dishPayloads);
      } else {
        await addDish(dishPayloads);
      }
      handleDialogClose();
    } catch (error) {
      console.error('Failed to save dish:', error);
      // Could add error handling here if needed
    }
  };

  return {
    dialogOpen,
    selectedDish,
    handleDishClick,
    handleDialogClose,
    handleAddNewDish,
    handleDishSave
  };
};

export default useDishDialog;